import { useEffect } from 'react';
import {
  clearPosNavbarCartState,
  publishPosNavbarCartState,
  subscribePosNavbarCartOpen,
} from '../utils/posNavbarCart';

const usePosNavbarCart = ({
  enabled = true,
  totalAmount = 0,
  onOpen,
} = {}) => {
  useEffect(() => {
    if (!enabled) {
      clearPosNavbarCartState();
      return undefined;
    }
    publishPosNavbarCartState({ visible: true, totalAmount });
    return () => {
      clearPosNavbarCartState();
    };
  }, [enabled, totalAmount]);

  useEffect(() => {
    if (!enabled || typeof onOpen !== 'function') {
      return undefined;
    }
    return subscribePosNavbarCartOpen(() => {
      onOpen();
    });
  }, [enabled, onOpen]);
};

export default usePosNavbarCart;
